export default {
  eyebrow: 'Portal do parceiro',
  title: 'Conta',
  description: 'Detalhes da sua conta de parceiro.',
  page: {
    read_only_notice: 'Só de leitura. Clique em Editar para alterar qualquer valor.',
    editing_notice: 'A editar — as alterações são visíveis para a sua equipa e clientes.',
  },
  profile: {
    form: {
      name: {
        label: 'Nome do parceiro',
        hint: 'O nome legal / da entidade. Usado em documentos de faturação.',
      },
      display_name: {
        label: 'Nome de exibição para o consumidor',
        hint: 'A etiqueta «Powered by ___» que os seus clientes veem nos seus restaurantes. Por omissão, usa o nome do parceiro se ficar em branco.',
      },
      support_email: {
        label: 'E-mail de contacto',
        hint: 'Como a FoodAmigos e os seus clientes o podem contactar. O e-mail de início de sessão não é alterado.',
      },
      invoicing_emails: {
        label: 'E-mails de faturas',
        hint: 'Os recibos das faturas emitidas em seu nome são enviados para cada um destes endereços. Deixe em branco para usar o seu e-mail de início de sessão.',
        placeholder: 'O seu e-mail de início de sessão',
      },
    },
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'Não foi possível carregar os detalhes da sua conta.',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
